import { Action } from '@ngrx/store';
import { Company } from '../models/companies-house.model';

export enum CompaniesActionTypes {
  COMPANIES_QUERY = '[Companies] Query',
  COMPANIES_LOADED = '[Companies] Fetched',

  COMPANIES_ADDED = '[Companies] Added',
  COMPANIES_EDITED = '[Companies] Edited',
  COMPANIES_DELETED = '[Companies] Deleted',
  COMPANIES_DELETEDALL = '[Companies] DeletedAll',
  COMPANIES_SAVED = '[Companies] Saved',

  COMPANIES_ERROR = '[Companies] Error'
}

export class CompaniesQuery implements Action {
  readonly type = CompaniesActionTypes.COMPANIES_QUERY;
}

export class CompaniesLoaded implements Action {
  readonly type = CompaniesActionTypes.COMPANIES_LOADED;

  constructor(public payload: { companies: Company[] }) {}
}

export class CompaniesAdded implements Action {
  readonly type = CompaniesActionTypes.COMPANIES_ADDED;

  constructor(public payload: { company: Company }) {}
}

export class CompaniesEdited implements Action {
  readonly type = CompaniesActionTypes.COMPANIES_EDITED;

  constructor(public payload: { company: Company }) {}
}

export class CompaniesSaved implements Action {
  readonly type = CompaniesActionTypes.COMPANIES_SAVED;

  constructor(public payload: {company: Company}) {}
}

export class CompaniesDeleted implements Action {
  readonly type = CompaniesActionTypes.COMPANIES_DELETED;

  constructor(public payload: { company: Company }) {}
}

export class CompaniesDeletedAll implements Action {
  readonly type = CompaniesActionTypes.COMPANIES_DELETEDALL;

  constructor(public payload: { company: Company }) {}
}


export class CompaniesError implements Action {
  readonly type = CompaniesActionTypes.COMPANIES_ERROR;

  constructor(public payload: { error: any }) {}
}

export type CompaniesActions =
  | CompaniesQuery
  | CompaniesLoaded
  | CompaniesAdded
  | CompaniesEdited
  | CompaniesSaved
  | CompaniesDeleted
  | CompaniesDeletedAll
  | CompaniesError;
